

import React, { useEffect } from 'react'
import Event from './eventImg/event-23-dec-2.webp'


const Event28 = () => {
    useEffect(() => {
        document.title = "Regrigeration Program on Sustainable Cold Chains";
      }, []);
  return (
    <>
    <div className='eventheading'>

      <h1 className='text-center'>23 December 2025</h1>
        <h3 className='text-center'>Regrigeration Program on Sustainable Cold Chains  </h3>
</div>
   <div className='container' id='calanderevent'>
<img src={Event} alt='Regrigeration Program on Sustainable Cold Chains'/>
<button className='mb-4'><a href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/QplusplusYWQaRM0M=' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event28




